<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{path:'/dashboard'}">Inicio</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Pagos de Jugadores (General)</li>
                        </ol>
                    </nav>
                </div>


                <div class="col-md-12" style="margin-bottom: 20px">

                    <div class="row">
                        <div class="col-md-2">
                            <br>
                            <router-link :to="{path:'/admin/pagos/1'}">
                                <button class="btn btn-sm btn-success">Vista mensual</button>
                            </router-link>
                        </div>
                    </div>

                    <div class="card" style="margin-top: 20px;">
                        <div class="table-responsive">
                            <table class="table table-bordered table-sm text-nowrap" id="table-players">
                                <thead class="table-dark">
                                <tr>
                                    <th></th>
                                    <th>Nombre</th>
                                    <th>Posicion</th>
                                    <th>Sede</th>
                                    <th>Día</th>
                                    <th>OCT</th>
                                    <th>NOV</th>
                                    <th>DIC</th>
                                    <th>ENE</th>
                                    <th>FEB</th>
                                    <th>MAR</th>
                                    <th>ABR</th>
                                    <th>MAY</th>
                                    <th>JUN</th>
                                </tr>
                                </thead>

                                <tbody>
                                <tr v-for="player in players">
                                    <th style="width: 50px">
                                        <button class="btn btn-sm"
                                                :class="{'btn-warning':player.comentario, 'btn-default':!player.comentario}"
                                                v-b-tooltip.hover.top
                                                :title="player.comentario"
                                                @click="openModalComentario(player)"
                                        ><i class="fa fa-pen"></i>
                                        </button>
                                    </th>
                                    <th style="vertical-align: middle">
                                        <span class="name mb-0 text-sm" id="name-player">{{player.apellidos | capitalizeText}}, {{player.nombre | capitalizeText}} </span>
                                    </th>
                                    <td v-if="player.posicion != 'Portero'" class="text-center"
                                        style="vertical-align: middle;">
                                        <span>JUGADOR</span>
                                    </td>
                                    <td v-else style="background-color: #76eea7; vertical-align: middle;"
                                        class="text-center">
                                        <span>PORTERO</span>
                                    </td>
                                    <td class="text-center" style="vertical-align: middle;">{{player.sede |
                                        parseSedePago}}
                                    </td>
                                    <td class="text-center" style="vertical-align: middle;">{{player.dia |
                                        parseDiaPago}}
                                    </td>
                                    <td v-for="pay in player.pays" :class="{'pagado': pay }">

                                    </td>

                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <modal :show.sync="modalEditComentario">
            <template slot="header">
                <h4 class="modal-title" id="exampleModalLabel">Editar comentario</h4>
            </template>
            <div>
                <div class="row">
                    <div class="col-md-12" style="margin-bottom: 20px">
                        <label><strong>Comentario</strong></label>
                        <input type="text" class="form-control" v-model="modal.comentario">
                    </div>
                </div>
            </div>
            <template slot="footer">
                <base-button type="secondary" @click="modalEditComentario = false">Cerrar</base-button>
                <base-button type="primary" @click="editarComentario(modal.player)">Guardar</base-button>
            </template>
        </modal>
    </div>
</template>
<script>
    import axios from 'axios';
    import swal from 'sweetalert2'
    import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'
    import flatPicker from "vue-flatpickr-component";
    import {Spanish} from 'flatpickr/dist/l10n/es'
    import "flatpickr/dist/flatpickr.css";


    export default {
        data() {
            return {
                players: [],
                modalEditComentario: false,
                modal: {
                    player: null,
                    comentario: ""
                },
                date: "today",
                configDate: {
                    allowInput: false,
                    altFormat: 'd-m-Y',
                    altInput: true,
                    dateFormat: 'Y-m-d',
                    locale: Spanish
                },
            };
        },
        components: {flatPicker},
        directives: {
            'b-tooltip': BTooltipDirective
        },
        created() {
            this.loadPlayers();
        },
        methods: {
            loadPlayers() {
                this.players = [];
                let vm = this;
                axios.get(this.$store.getters.apiUrl + 'players-pagos-general', {
                    params: {
                        jwt: vm.$store.getters.jwt,
                        season: vm.$store.getters.season
                    }
                }).then(response => {
                    if (response.data.response) {
                        vm.players = response.data.result;
                    } else {
                        swal({
                            title: 'Atención',
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                    }
                }).catch(e => {
                    swal({
                        title: 'Atención',
                        text: e,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                });
            },
            openModalComentario(player) {
                this.modal.player = player;
                this.modal.comentario = player.comentario;
                this.modalEditComentario = true;
            },
            editarComentario(player) {
                player.comentario = this.modal.comentario;
                let vm = this;
                axios.post(this.$store.getters.apiUrl + 'players/' + player.id + '/editar-comentario', {
                    idPlayer: player.id,
                    comentario: vm.modal.comentario,
                    jwt: this.$store.getters.jwt
                }).then(response => {
                    if (response.data.response) {
                        vm.modalEditComentario = false;
                    } else {
                        swal({
                            title: 'Atención',
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                    }
                }).catch(e => {
                    swal({
                        title: 'Atención',
                        text: e,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                });
            },
        }

    };
</script>
<style scoped>

    .container-fluid {
        margin-top: 39px;
    }

    .card {
        background-color: #f7fafc !important;
        box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.30) !important;
        border: 1px solid rgba(0, 0, 0, .05);
        border-radius: .375rem;
    }

    #table-players tbody tr:hover {
        background-color: rgba(62, 92, 75, 0.3);
    }

    td, th {
        padding-left: 10px !important;
        padding-right: 10px !important;
    }

    .pagado {
        background-color: #1fa2ff;
    }

    .comentario {
        cursor: pointer;
        background-color: #fb6340;
    }

</style>
